import http from 'plugins/axios';

export default {
    getStatistics(data) {
        return http.get({
            url: '/admin/snapshot/statistics/list',
            data
        });
    },
    createFlow(data) {
        return http.post({
            url: '/admin/snapshot/statistics/flow/create',
            data,
            dataType: 'form'
        })
    },
    listFlow(data) {
        return http.get({
            url: '/admin/snapshot/statistics/flow/list',
            data
        })
    },
    removeFlow(data) {
        return http.post({
            url: '/admin/snapshot/statistics/flow/remove',
            data,
            dataType: 'form'
        })
    }
};
